import { render, staticRenderFns } from "./account-status-bar.vue?vue&type=template&id=3530b578&scoped=true&"
import script from "./account-status-bar.vue?vue&type=script&lang=ts&"
export * from "./account-status-bar.vue?vue&type=script&lang=ts&"
import style0 from "./account-status-bar.vue?vue&type=style&index=0&id=3530b578&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530b578",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
